import { mapGetters, mapState } from 'vuex'
import PaymentMethodsConf from '@/configuration/sources/smartform/paymentMethodsConf.yml'

/**
 * Mixin to manage the grid configuration in the components that require it
 */
export default {
  data() {
    return {
      radioBtnWidth: 0
    }
  },
  computed: {
    ...mapGetters([
      'effectiveNonPreferredPMGroupList',
      'effectivePreferredPMGroupList'
    ]),
    ...mapState({
      pmSectionConfig({ smartForm }) {
        const pmSectionKey =
          this.section === 'opm'
            ? 'otherPaymentMethodsLayout'
            : 'preferredPaymentMethodsLayout'

        return smartForm[pmSectionKey] || {}
      }
    }),
    paymentMethodGroups() {
      return this.section === 'opm'
        ? this.effectiveNonPreferredPMGroupList
        : this.effectivePreferredPMGroupList
    },
    labelVisibility() {
      const { labelVisibility } = this.pmSectionConfig
      const validValues = ['show', 'hide', 'auto']

      if (!validValues.includes(labelVisibility)) {
        return 'show'
      }
      return labelVisibility
    },
    configCols() {
      const columns = this.pmSectionConfig.grid.columns
      if (columns === 'max') return columns
      return parseInt(columns) || 1
    },
    configJustify() {
      return this.pmSectionConfig.grid.justify
    },
    configColMinWidth() {
      const minWidth =
        parseInt(this.pmSectionConfig.grid.button.minWidth) || 100
      return minWidth + this.radioBtnWidth
    },
    configButtonPaddingRight() {
      const { paddingRight } = this.pmSectionConfig.grid.button
      return parseInt(paddingRight) || 0
    },
    configButtonPaddingY() {
      const { paddingY } = this.pmSectionConfig.grid.button
      return parseInt(paddingY) || 0
    },
    configButtonSPBThresholdSmall() {
      const { threshold } =
        this.pmSectionConfig.grid.button.$singlePaymentButton
      return parseInt(threshold.small) || 0
    },
    columns() {
      const groupConf = PaymentMethodsConf.groups[this.group]
      if (this.group && groupConf) {
        const groupCols = groupConf.grid?.columns || this.configCols
        // Group config auto falls back to global config
        return groupCols === 'auto' ? this.configCols : groupCols
      }
      return this.configCols
    },
    justify() {
      const groupConf = PaymentMethodsConf.groups[this.group]
      if (this.group && groupConf) {
        return groupConf.grid?.justify ?? this.configJustify
      }
      return this.configJustify
    },
    colMinWidth() {
      const groupConf = PaymentMethodsConf.groups[this.group]
      if (this.group && groupConf) {
        return groupConf.grid?.minWidth ?? this.configColMinWidth
      }
      return this.configColMinWidth
    }
  }
}
